import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query'

import { getGisMandals } from '../api/gisApi'

import type { GisScope } from '../api/types'

/**
 * Bulk per-mandal metrics + district rollup. Lens is NOT in the key — lenses are a
 * pure client-side recolor of the same payload. The scope (period + entity + custom range)
 * IS in the key. Backend TTL-caches for 300s, so a 2-minute staleTime keeps repeat navigations
 * instant without going stale within the window.
 */
export const gisMandalsQueryOptions = (scope: GisScope) =>
  queryOptions({
    queryKey: ['gis', 'mandals', scope.period, scope.entityId ?? null, scope.dateFrom ?? null, scope.dateTo ?? null] as const,
    queryFn: () => getGisMandals(scope),
    staleTime: 1000 * 60 * 2,
    placeholderData: keepPreviousData,
  })

export function useGisMandals(scope: GisScope) {
  return useQuery(gisMandalsQueryOptions(scope))
}
